import { Directive, inject, model } from '@angular/core';
import { ButtonComponent } from '../button.component';
import { ButtonMode } from '../model';

@Directive({
    selector: '[linkButton]',
    standalone: true,
    host: {
        '[class.btn-link-underline]': '$underline()',
    }
})
export class LinkButtonDirective {

    public readonly buttonComponent = inject(ButtonComponent);

    public $underline = model<boolean>(false, { alias: 'underline' });


    constructor() {
        this.buttonComponent.$mode.set(ButtonMode.Link);
    };

}